module.exports = __webpack_public_path__ + "img/extermination-immobilieres.6db67ae9.jpg";